import { UseQueryOptions, useQuery } from '@tanstack/react-query'

import { getImportRequestLabels } from 'services/import-requests'
import { ImportRequestQueryKeys } from 'services/import-requests/queryKeys'
import type { GetImportRequestLabelsResponse } from 'services/import-requests/types'
import type { ApiErrorResponse } from 'services/types'

export const useGetImportRequestLabelsFilter = (
  options?: Omit<UseQueryOptions<GetImportRequestLabelsResponse, ApiErrorResponse>, 'queryKey'>
) =>
  useQuery<GetImportRequestLabelsResponse, ApiErrorResponse>({
    queryKey: ImportRequestQueryKeys.FilterLabels(),
    queryFn: ({ signal }) => getImportRequestLabels({ signal }),
    ...options
  })
